import { Injectable, inject } from '@angular/core';
import { WordReplacement } from '../text-processor/text-processor.interface';
import { ApiService } from 'capiche-api';
import { UserService } from 'capiche-auth';
import { ReplacementRequest } from '../core/dto';
import { CapicheLoggerService } from 'capiche-logger';
import { CAPICHE_TEXT_PROCESSOR_CONFIG } from '../capiche-text-processor.config';

// TODO: Should this class be a subtype? Then it can share with the lookups???

@Injectable({
  providedIn: 'root',
})
export class UserReplacementRepository extends ApiService {
  private readonly config = inject(CAPICHE_TEXT_PROCESSOR_CONFIG);
  private capicheApiBaseUrl = this.config.baseApiUrl;
  private replacementsEndpoint = `${this.capicheApiBaseUrl}/v1/replacements`;

  override logger: CapicheLoggerService = new CapicheLoggerService('userReplacementRepository:', false);

  constructor(userService: UserService) {
    super(userService);
    this.logger.log('constructor');
    this.logger.log('userService:', userService);
    this.logger.log('capicheApiBaseUrl:', this.capicheApiBaseUrl);
    this.logger.log('replacementsEndpoint:', this.replacementsEndpoint);
  }

  /**
   * Stores replacement data as users. TODO This needs to be a replaementrequest
   */
  public async storeReplacementData(wordReplacement: WordReplacement) {
    // Create request. TODO: Make helper class
    const replacementRequest: ReplacementRequest = {
      attributes: {
        lookupWord: wordReplacement.word.input.toLocaleLowerCase(),
        // TODO: spelling should be typed as part of the refactor
        //suggestions: wordReplacement.word.spelling?.suggestions.map((sugg: suggestionDTO) => sugg.word),
        suggestions: wordReplacement.word.suggestions?.map((sugg) => sugg.word),
        chosenSuggestion: wordReplacement.suggestion,
        timestamp: new Date(),
      },
    } as ReplacementRequest;

    return await this.post(`${this.replacementsEndpoint}/${this.currentUser?.uid}`, replacementRequest);
  }
}
